import React, { useEffect, useState } from 'react'
import { FormContext, useForm } from 'react-hook-form'
import { Grid } from 'react-md'

import { handleSubmit, InputDatePicker, InputTime } from 'components/form'
import { Modal } from 'components/core'

import { defaultValues, validationSchema } from './config'
import { handleGetNextVisitEquipment, handleSave } from './actions'

import NextVisitDateEquipment from './components/next-visit-date-equipment'

interface ComponentProps {
  technicalVisitId: string
  loadNextVisitDates: boolean
  visibleModal: boolean
  disableModal: () => void
  loadTechnicalVisit: () => Promise<void>
}

const Component: React.FC<ComponentProps> = ({ technicalVisitId, loadNextVisitDates, visibleModal, disableModal, loadTechnicalVisit }) => {
  const form = useForm({ defaultValues })
  const [equipments, setEquipments] = useState<Array<any>>()

  useEffect(() => {
    const loadNextVisitEquipment = async () => {
      if (loadNextVisitDates) setEquipments(await handleGetNextVisitEquipment(technicalVisitId))
    }

    loadNextVisitEquipment()

    return () => {}
  }, [loadNextVisitDates, technicalVisitId])

  return (
    <Modal
      title={'Finalização de Visita Técnica'}
      visible={visibleModal}
      confirmTitle={'Salvar'}
      confirmDisabled={!form.formState.dirty}
      confirmAction={async () => {
        await handleSubmit(form, validationSchema, async () => {
          await handleSave({ technicalVisitId, ...form.getValues() })
          form.reset(defaultValues, { dirty: false })
          loadTechnicalVisit()
          disableModal()
        })
      }}
      closeTitle={'Fechar'}
      closeAction={async () => {
        form.reset(defaultValues, { dirty: false })
        disableModal()
      }}>
      <Grid>
        <FormContext {...form}>
          <InputTime name='arrivalTime' label='Horário de Chegada *' desktopSize={4} tabletSize={4} />
          <InputTime name='exitTime' label='Horário de Saída *' desktopSize={4} tabletSize={4} />
          <InputDatePicker name='nextTechnicalVisit' label='Data da Próxima Visita' desktopSize={4} tabletSize={4} />
        </FormContext>
      </Grid>
      <NextVisitDateEquipment equipments={equipments} />
    </Modal>
  )
}

export default Component
